import PropTypes from "prop-types";
import TablePagination from "@mui/material/TablePagination";
import { gr } from "../tokens";

// Page controls under a GrDataTable: "Rows per page" select, "1–50 of 120", previous / next.
// Same behaviour and wording as MUI's TablePagination (used by the older tables); GymRite look.
export default function GrTablePagination({
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = [10, 50, 100, 200, 500],
  sx,
}) {
  return (
    <TablePagination
      component="div"
      count={count || 0}
      page={page}
      rowsPerPage={rowsPerPage}
      onPageChange={onPageChange}
      onRowsPerPageChange={onRowsPerPageChange}
      rowsPerPageOptions={rowsPerPageOptions}
      sx={{
        mt: gr.space[3],
        pt: gr.space[3],
        borderTop: `1px solid ${gr.color.line2}`,
        fontFamily: gr.font.family,
        color: gr.color.ink2,
        overflow: "hidden",
        "& .MuiToolbar-root": {
          minHeight: gr.control.md,
          px: 0,
          flexWrap: "wrap",
          justifyContent: "flex-end",
          rowGap: gr.space[2],
        },
        "& .MuiTablePagination-spacer": { display: "none" },
        "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
          m: 0,
          fontFamily: gr.font.family,
          fontSize: gr.font.size.sm,
          color: gr.color.ink2,
        },
        "& .MuiTablePagination-input": {
          mr: gr.space[4],
          ml: gr.space[2],
          fontFamily: gr.font.family,
          fontSize: gr.font.size.sm,
          color: gr.color.ink,
          border: `1px solid ${gr.color.line}`,
          borderRadius: gr.radius.control,
        },
        "& .MuiTablePagination-select": { py: gr.space[2] },
        "& .MuiTablePagination-actions": {
          ml: gr.space[2],
          display: "flex",
          gap: gr.space[1],
        },
        "& .MuiTablePagination-actions .MuiIconButton-root": {
          width: gr.control.md,
          height: gr.control.md,
          borderRadius: gr.radius.control,
          color: gr.color.ink2,
          "&:hover": { background: gr.color.tint, color: gr.color.brandDark },
          "&.Mui-focusVisible": { boxShadow: gr.shadow.focus },
          "&.Mui-disabled": { color: gr.color.lineStrong },
        },
        ...sx,
      }}
    />
  );
}

GrTablePagination.propTypes = {
  count: PropTypes.number,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onRowsPerPageChange: PropTypes.func,
  rowsPerPageOptions: PropTypes.array,
  sx: PropTypes.object,
};
